/**
 * 首页-备模块
 */
import { request } from 'hxhy-axios'
import { apiList as api } from './apiList'

// 查询学程列表
export function getCourseList(data) {
  return request({
    url: api.indexBei.getCourseList,
    method: 'post',
    data,
  })
}

// 新建学程
export function saveCourse(data) {
  return request({
    url: api.indexBei.saveCourse,
    method: 'put',
    data,
  })
}

// 获取用户任教信息
export function getUserSubject(userId) {
  return request({
    url: api.indexBei.getUserSubject + userId,
    method: 'get',
  })
}

// 学程编辑
export function curriculumSetCreateFun(id) {
  return request({
    url: api.indexBei.curriculumSetCreate + id,
    method: 'get',
  })
}

// 引用学程
export function curriculumCiteFun(id) {
  return request({
    url: `${api.indexBei.curriculumCite}${id}`,
    method: 'get',
  })
}

// 习练引用
export function practicePaperCite(id) {
  return request({
    url: `${api.indexBei.practicePaperCite}${id}`,
    method: 'put',
  })
}

// 获取群组发布信息
export function getGroupPubInfo(userId) {
  return request({
    url: api.indexBei.getGroupPubInfo + userId,
    method: 'get',
  })
}

// 检测学程整个目录是否完整
export function courseIsCatelogFully(id) {
  return request({
    url: api.indexBei.courseIsCatelogFully + id,
    method: 'get',
  })
}

// 获取学程已发布群组
export function getCoursePubGroups(courseId) {
  return request({
    url: api.indexBei.getCoursePubGroups + courseId,
    method: 'get',
  })
}

// 获取习练发布信息
export function getGroupInformation(paperId) {
  // 获取指定习练发布的群组信息
  return request({
    url: api.indexBei.groupInformation + paperId,
    method: 'get',
  })
}

// 获取群组发布信息-习练
export function getPubGroupList(userId, paperId) {
  return request({
    url: api.indexBei.getPubGroupList + userId + '/' + paperId,
    method: 'get',
  })
}

// 获取学程目录树
export function getCourseTree(courseId) {
  return request({
    url: api.indexBei.getCourseTree + courseId,
    method: 'get',
  })
}

// 学程发布
export function pubCourse(data) {
  return request({
    url: api.indexBei.pubCourse,
    method: 'post',
    data,
  })
}

// 发布习练
export function getExercisesPaperPub(data) {
  return request({
    url: api.indexBei.exercisesPaperPub,
    method: 'post',
    data,
  })
}

/**
 * 获取习题列表
 * @returns
 */
export function getExercisePage(data) {
  return request({
    url: api.indexBei.getExercisePage,
    method: 'post',
    data,
  })
}

/**
 * 习练列表
 */
export function getExercisesPaperPage(params) {
  return request({
    url: api.indexBei.getExercisesPaperPage,
    method: 'get',
    params,
  })
}

/**
 *资源收藏/取消收藏
 * @returns
 */
export function collectResource(data) {
  return request({
    url: api.indexBei.collectResource,
    method: 'put',
    data,
  })
}

/**
 * 学程收藏
 * @returns
 */
export function collectCourse(id) {
  return request({
    url: `${api.indexBei.collectCourse}${id}`,
    method: 'get',
  })
}
/**
 *资源引用至创作中心
 * @returns
 */
export function copyResource(id) {
  return request({
    url: `${api.indexBei.copyResource}${id}`,
    method: 'post',
  })
}
/**
 * 学程引用
 * @returns
 */
export function copyCourse(id) {
  return request({
    url: `${api.indexBei.copyCourse}${id}`,
    method: 'get',
  })
}
/**
 * 教师工作台->获取推荐资源列表
 * @returns
 */
export function getRecommendList() {
  return request({
    url: `${api.indexBei.getRecommendList}`,
    method: 'get',
  })
}
